import { gql, TypedDocumentNode } from "@apollo/client";

import { QuerySearchTemplatesArgs } from "types/generated";

type CheckTemplatesData = {
  searchTemplates: {
    edges: Array<{
      node: {
        id: string;
      };
    }>;
  };
};

export const CHECK_TEMPLATES: TypedDocumentNode<
  CheckTemplatesData,
  QuerySearchTemplatesArgs
> = gql`
  query CheckTemplates {
    searchTemplates(input: { first: 1 }) {
      edges {
        node {
          id
        }
      }
    }
  }
`;
